// Module-level catalogue cache: survives route changes so Home ⇄ Detail
// navigation renders instantly from memory while fresh data loads silently.
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL;
const MAX_AGE_MS = 5 * 60 * 1000;

let cache = { mobiles: null, fetchedAt: 0, promise: null };

export function getCachedMobiles() {
  return cache.mobiles;
}

export function getCachedMobileById(id) {
  if (!Array.isArray(cache.mobiles)) return null;
  return cache.mobiles.find((m) => String(m._id) === String(id)) || null;
}

export function fetchMobiles({ force = false } = {}) {
  const isFresh = cache.mobiles && Date.now() - cache.fetchedAt < MAX_AGE_MS;
  if (isFresh && !force) return Promise.resolve(cache.mobiles);
  if (cache.promise) return cache.promise;

  cache.promise = axios
    .get(`${API_BASE}/api/mobiles`, { withCredentials: true })
    .then((res) => {
      if (Array.isArray(res.data)) {
        cache.mobiles = res.data;
        cache.fetchedAt = Date.now();
      }
      return cache.mobiles || [];
    })
    .finally(() => {
      cache.promise = null;
    });

  return cache.promise;
}
